import { useEffect, useState } from 'react';
import * as React from 'react';
import { useMatch, useParams } from 'react-router-dom';

import { useNavigate } from '@web/Router/router.hooks';
import { PathnameEnum } from '@web/Router/router.types';

type Props = {
  onFilterQueryChange: (value: string) => void;
};
export const useSearchForm = ({ onFilterQueryChange }: Props) => {
  const match = useMatch(PathnameEnum.CONVERSATION_SEARCH);
  const { id } = useParams();
  const navigate = useNavigate();

  const [lastActiveConversationId, setLastActiveConversationId] = useState<ID | null>(null);
  const [query, setQuery] = useState('');

  const isSearchResultsActive = !!match;

  useEffect(() => {
    !isSearchResultsActive && setQuery('');
  }, [isSearchResultsActive]);

  const handleChange = (e: React.FormEvent<HTMLInputElement>) => {
    const value = e.currentTarget.value;

    setQuery(value);
    !isSearchResultsActive && onFilterQueryChange(value);
  };

  const handleReset = () => {
    setQuery('');
    onFilterQueryChange('');

    if (!isSearchResultsActive) return;

    if (lastActiveConversationId) {
      navigate.toConversationDetails({
        params: {
          id: lastActiveConversationId,
        },
      });
    } else {
      navigate.toConversationRoot();
    }
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!query) return;

    id && setLastActiveConversationId(+id);
    onFilterQueryChange('');

    navigate.toConversationSearch({
      queryParams: {
        query,
      },
    });
  };

  return {
    handleChange,
    handleReset,
    handleSubmit,
    isSearchResultsActive,
    query,
  };
};
